import * as _ from 'lodash';
import {
  UserScheme,
  UserPartnerForEditScheme,
  UserPartnerManagerForEditScheme,
  UserPartnerIntegratedForEditScheme,
} from '../../utilities/JoiSchemes';
import { isPartnerRoleId, isForemanRoleId } from '../../utilities/roleUtility';
import { validationByJoi } from '../../utilities/commonValidation';

/**
 * 画像ファイルアイコン処理
 * @param {object} base64 画像ファイルアイコン情報
 * @returns 画像ファイルアイコン処理結果
 */
const getBinary = base64 => {
  // Base64からバイナリへ変換
  const bin = atob(base64.replace(/^.*,/, ''));
  var buffer = new Uint8Array(bin.length);
  for (var i = 0; i < bin.length; i++) {
    buffer[i] = bin.charCodeAt(i);
  }
  return buffer.buffer;
};

/**
 * 更新・登録用のリクエストデータを作成する
 *
 * @param {object} params
 * @return {object} form_data
 * */
const createRequestParam = params => {
  let form_data = new FormData();

  _.each(params, (val, key) => {
    if (key === 'user_image' && val !== '') {
      let image = val.match(/image\/(.+);/);
      if (!image) {
        return;
      }
      const type = image[1];
      val = new Blob([getBinary(val)], { type: `image/${type}` });
    }
    form_data.append(key, val);
  });

  return form_data;
};

/**
 * @description 入力パラメータチェック
 * @param {object} params 全入力パラメータ
 * @param {string} id 入力フォームID
 * @param {boolean} isPrimary 元請会社フラグ
 * @returns true: 正常値, false: 異常値
 */
const isNormalValue = (params, id, isPrimary) => {
  const result = validate(params, isPrimary);
  if (!_.has(result.messages, id)) {
    // 正常に入力されていた場合
    return true;
  } else {
    // 未入力、または正常に入力されていない場合
    return false;
  }
};

/**
 * @description 入力パラメータチェック
 * @param {object} params 全入力パラメータ
 * @param {boolean} isPrimary 元請会社フラグ
 * @returns チェック結果
 */
const validate = (params, isPrimary) => {
  if (isPrimary === false) {
    if (isPartnerRoleId(params.user_role_code)) {
      return validationByJoi(UserPartnerManagerForEditScheme, params);
    }
    if (isForemanRoleId(params.user_role_code)) {
      if (params.integrated) {
        return validationByJoi(UserPartnerIntegratedForEditScheme, params);
      }
      return validationByJoi(UserPartnerForEditScheme, params);
    }
  }
  return validationByJoi(UserScheme, params);
};

/**
 * @description 必須項目入力数の分子を計算
 * @returns 必須項目入力数の分子
 */
const getFraction = (params, requiredList) => {
  let num = 0;
  _.map(Object.keys(requiredList), val => {
    if (params[val]) {
      num += 1;
    }
  });
  return num;
};

/**
 * 利用者詳細・編集・新規登録画面のサービスクラス
 * */
const UserService = {
  createRequestParam,
  isNormalValue,
  validate,
  getFraction,
};

export default UserService;



// WEBPACK FOOTER //
// ./src/services/user/UserService.js